import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GalleryService } from '../../providers/gallery.service';
import { LoggerService } from '../../providers/logger.service';

@Component({
  selector: 'app-redirect-oauth',
  templateUrl: './redirect-oauth.component.html',
  styleUrls: ['./redirect-oauth.component.css']
})
export class RedirectOauthComponent implements OnInit {

  OAuthProvider: any;// $routeParams['oauthprovider'];

  constructor(private logger: LoggerService,
    private route: ActivatedRoute,
    private router: Router,
    private gallery: GalleryService) { }

  ngOnInit(): void {
    this.OAuthProvider = this.route.snapshot.params['oauthprovider'];
    this.activate();
  }

  activate() {
    try {

      var params = '';
      var code = this.route.snapshot.params['param1'];
      var state = this.route.snapshot.params['param2'];
      if (state === undefined || state === null)
        state = '';

      params = 'code=' + encodeURIComponent(code) + '&state=' + state;

      this.gallery.doOAuthLogin(this.OAuthProvider, params).then(
        (data) => {
          try {
            if (data['url']) {
              this.router.navigateByUrl(data['url'])
            } else {
              console.log('Got invalid response.', data);
              this.logger.write2log('redirect-oauth-activate.2', 'Got invalid response.', 'E');
              this.router.navigateByUrl('/login?user_id=_');
            }
          } catch (e) {
            this.logger.write2log('redirect-oauth-activate.3', e.message, 'E');
            this.router.navigateByUrl('/login?user_id=_');
          }
        });

    } catch (e) {
      this.logger.write2log('redirect-oauth-activate', e.message, 'E');
    }
  }

}
